// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-layouts-default-layout-tsx": () => import("/opt/build/repo/src/layouts/DefaultLayout.tsx" /* webpackChunkName: "component---src-layouts-default-layout-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/build/repo/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

